import './ele-ui' // element-ui 按需加载
import 'element-ui/lib/theme-chalk/index.css'
import './styles/base.less'
import 'swiper/dist/css/swiper.css'
import './styles/zj-alert.less'

import Vue from 'vue'
// import ELEMENT from 'element-ui'
import Meta from 'vue-meta'
import VueLazyload from './assets/lib/vue-lazyload/src/index'
import Vuebar from 'vuebar'
import $ from 'jquery'
import _ from 'lodash'

// 第三方vue组件
// import Aplayer from 'vue-aplayer'
import VueProgressBar from 'vue-progressbar'
import VueTimeago from 'vue-timeago'

// import VueClipboards from 'vue-clipboards'

// import Bscroll from 'better-scroll'
import ECharts from 'echarts'

// eventBus
import plugin from './plugin/index'

// 全局组件
import './components/index.js'

// vue滑块
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Theme from './assets/lib/echart-themes'
import store from './store/'
import './filters/index'
import './directives/index'
import App from './App'
import router from './router/'
import Notice from './components/notice'
import MsgBox from './components/message-box'
import './sentry'
// API 组件 test
// Vue.use(VueClipboards)
// Vue.use(ELEMENT, {
//   size: 'medium',
//   zIndex: 3000
// })
Vue.use(plugin)
Vue.use(VueAwesomeSwiper)
Vue.use(Meta)
Vue.use(VueProgressBar, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '2px'
})

// or with options
Vue.use(VueLazyload, {
  lazyComponent: true,
  preLoad: 1.3,
  error: require('./assets/lib/lazyload/img/error.png'),
  loading: require('./assets/lib/lazyload/img/loading.gif'),
  attempt: 2
})

Vue.use(Vuebar)

// let VConsole = require('vconsole')
// let vConsole = new VConsole()

Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: 'zh-CN', // Default locale
  locales: {
    'zh-CN': require('date-fns/locale/zh_cn'),
    'ja': require('date-fns/locale/ja')
  }
})
// Vue.use(VueClip)
// import './fundebug.js'

// Vue.prototype.$ELEMENT = { size: 'medium', zIndex: 3000 }
// Vue.prototype.$notify = ELEMENT.Notification
// Vue.prototype.$message = ELEMENT.Message

// 注册 echarts 主题
ECharts.registerTheme('macarons', Theme)
let _Echarts = {}
_Echarts.init = ECharts.init
ECharts.init = function (dom, theme, opts) {
  return _Echarts.init.call(null, dom, (theme || 'macarons'), opts)
}
// require('mathjax')
window.$ = window.jQuery = $
window._ = _
Vue.config.performance = false
Vue.config.productionTip = false
Vue.prototype.$echarts = ECharts
Vue.prototype.$MsgBox = MsgBox
// Vue.prototype.$http = request
// Vue.prototype.$notice = Notice
console.log(Vue.prototype)

export default new Vue({
  store,
  router,
  render: h => h(App),
  mounted () {
    // // 哀悼模式
    // if (new Date() < new Date('2020-04-06')) {
    //   $('html').append('<style>\n' +
    //     'html{filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);-webkit-filter:grayscale(100%);}\n' +
    //     '</style>')
    // }
  }
}).$mount('#app')
